module.exports = __webpack_public_path__ + "img/distribution.f78b7ba7.svg";